// ADENDA z60 (Diego, 29-oct-2026; caso de Miguel, recibo 1F mensual de un servicio NUEVO desde el 16-feb-26): «Juan y Miguel
// están usando ChatGPT por fuera del cotizador porque en el cotizador se está confundiendo… hazlo más sencillo». El recibo
// traía 8 periodos desde el alta (el primero de 23 días y los 5 primeros casi en cero: la casa no se usaba) y 3 meses de
// verano reales; Miguel estimó los 5 con ChatGPT y, para llegar a 12, agregó 4 meses HACIA ADELANTE sin fechas («Octubre»…
// «Enero»), que el motor no puede ubicar. Aquí vive «Completar el año», UNA regla que comparten la pantalla (botón de la
// tabla de Revisión) y el motor (aviso de los meses casi en cero):
//   · el año que se cotiza son los 12 meses (o 6 bimestres) que terminan en el último recibo, en sus fechas de calendario y
//     con la periodicidad del recibo; los que faltan se llenan HACIA ATRÁS (antes del primero) y en los huecos;
//   · el primer periodo del alta (más corto que un periodo) se toma como el periodo completo que termina en su corte;
//   · los periodos sin fechas que se agregaron al final («Octubre»…) pasan al lugar que les toca (por su mes, si lo dice);
//   · en un historial incompleto, los meses casi en cero AL PRINCIPIO (servicio nuevo, casa sin habitar) no representan el
//     consumo: se estiman también;
//   · lo estimado sale de la curva de Sonora (casa o negocio, la MISMA del motor) escalada con los meses reales.
// Todo lo estimado queda marcado (origen «estimado»): el motor lo cuenta como estimado y el PDF lo dice.
// ADENDA z61 (Diego, 29-oct ~13:10, «lo antes posible»; MANDA sobre lo de arriba): «siempre nos basamos en los últimos 12 meses».
// Al cargar el o los recibos la tabla de Revisión YA TRAE los periodos que faltan hacia atrás, con sus fechas y los kWh EN BLANCO
// (`vacios` de este plan); el vendedor los escribe o aprieta «Sugerir con IA», que los llena con esta misma estimación (la curva
// de calor de Sonora escalada con los meses reales, y también los casi en cero del principio), marcados «estimado».
import { PERFIL_CONSUMO_CASA } from './ajuste-consumos.ts';
import { mesDelRenglon, ventanaDelAnio } from './dominio/recibo.ts';
import { numero } from './dinero.ts';

/** Fracción del consumo anual de un NEGOCIO en Sonora por mes (ENE…DIC; suma 1): copia de paquetes/motor/datos/
 *  consumo-perfiles.json (negocio). El motor TRUENA al cargar si dejan de coincidir (datos.ts). */
export const PERFIL_CONSUMO_NEGOCIO: readonly number[] = Object.freeze([0.05317, 0.05427, 0.06292, 0.07852, 0.08692, 0.10562, 0.11897, 0.12218, 0.10897, 0.08957, 0.06592, 0.05297]);

/** Un mes es «casi en cero» si su consumo es menos de esta fracción de lo que da la curva de Sonora con los meses reales. */
export const CASI_EN_CERO_FRACCION = 0.25;

const DIA_MS = 86_400_000;
const FECHA = /^\d{4}-\d{2}-\d{2}$/;
const MESES = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'] as const;
const MESES_CORTOS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'] as const;
const aDia = (f: string) => Date.UTC(Number(f.slice(0, 4)), Number(f.slice(5, 7)) - 1, Number(f.slice(8, 10))) / DIA_MS;
const deDia = (n: number) => new Date(Math.round(n) * DIA_MS).toISOString().slice(0, 10);
const dias = (inicio: string, fin: string) => Math.round(aDia(fin) - aDia(inicio));
const esFecha = (f: string | null | undefined): f is string => !!f && FECHA.test(f) && !Number.isNaN(aDia(f)) && deDia(aDia(f)) === f;

/** Suma meses a una fecha conservando el día (31 → fin de mes si no existe): la misma regla que el motor (fechas.ts). */
export function sumarMesesFecha(fecha: string, n: number): string {
  const [a, m, d] = fecha.split('-').map(Number) as [number, number, number];
  const base = new Date(Date.UTC(a, m - 1 + n, 1));
  const dim = new Date(Date.UTC(base.getUTCFullYear(), base.getUTCMonth() + 1, 0)).getUTCDate();
  return new Date(Date.UTC(base.getUTCFullYear(), base.getUTCMonth(), Math.min(d, dim))).toISOString().slice(0, 10);
}

/** «16 OCT 25-16 NOV 25»: la etiqueta de un periodo que pone el cotizador (como las de CFE; el motor la sabe leer). */
export function etiquetaDeFechas(inicio: string, fin: string): string {
  const e = (f: string) => `${Number(f.slice(8, 10))} ${MESES[Number(f.slice(5, 7)) - 1]} ${f.slice(2, 4)}`;
  return `${e(inicio)}-${e(fin)}`;
}

/** «16 oct 25» (para los textos al vendedor y los avisos del motor). */
export const diaMesCorto = (f: string) => `${Number(f.slice(8, 10))} ${MESES_CORTOS[Number(f.slice(5, 7)) - 1]} ${f.slice(2, 4)}`;
/** «jul–oct 26» / «nov 25 – feb 26»: de qué meses habla un tramo de periodos (por el mes de su punto medio). */
export function tramoDeMeses(inicio: string, fin: string): string {
  const mes = (f: string) => { const d = new Date(aDia(f) * DIA_MS); return { m: d.getUTCMonth(), a: String(d.getUTCFullYear()).slice(2) }; };
  const a = mes(inicio), b = mes(deDia(aDia(fin) - 1));
  if (a.a === b.a) return a.m === b.m ? `${MESES_CORTOS[a.m]} ${a.a}` : `${MESES_CORTOS[a.m]}–${MESES_CORTOS[b.m]} ${b.a}`;
  return `${MESES_CORTOS[a.m]} ${a.a} – ${MESES_CORTOS[b.m]} ${b.a}`;
}

/** Peso del periodo [inicio, fin) en el año con el perfil (la suma, día por día, de la fracción de su mes entre los días del
 *  mes): la misma cuenta que el motor (sumaPorDias) y que el ajuste con IA (pesoDelPeriodo). */
export function pesoDelPeriodoEnElAnio(inicio: string, fin: string, perfil: readonly number[]): number {
  let s = 0;
  for (let d = aDia(inicio); d < aDia(fin); d++) {
    const x = new Date(d * DIA_MS);
    const diasMes = new Date(Date.UTC(x.getUTCFullYear(), x.getUTCMonth() + 1, 0)).getUTCDate();
    s += perfil[x.getUTCMonth()]! / diasMes;
  }
  return s;
}

const mediana = (xs: readonly number[]) => {
  const o = [...xs].sort((a, b) => a - b);
  return o.length % 2 ? o[(o.length - 1) / 2]! : (o[o.length / 2 - 1]! + o[o.length / 2]!) / 2;
};

/** Los periodos CASI EN CERO AL PRINCIPIO de una serie en orden (del más viejo al más nuevo): cada uno usa menos de
 *  CASI_EN_CERO_FRACCION de lo que da la curva de Sonora con los meses que sí se usan (consumo ÷ su peso en el año contra la
 *  mediana de los meses «altos»), y van seguidos desde el primero. Así no se marcan los meses de invierno (la curva ya los
 *  espera bajos) ni un mes bajo a la mitad del año; el más nuevo nunca (es el recibo que ancla el año). Devuelve sus
 *  posiciones en la serie. `desde` (hoy83): dónde empieza el RECIBO en la serie; los renglones de antes los escribió el vendedor
 *  («Agregar antes»: meses de antes del alta) y no son candidatos (sí cuentan para saber cuánto usa la casa). */
export function casiEnCeroAlInicio(consumos: readonly number[], pesos: readonly number[], desde = 0): number[] {
  const r = consumos.map((c, k) => (pesos[k]! > 0 && Number.isFinite(c) ? c / pesos[k]! : Number.NaN));
  const validos = r.filter(Number.isFinite);
  if (validos.length < 2) return [];
  const max = Math.max(...validos);
  if (!(max > 0)) return [];
  const referencia = mediana(validos.filter((x) => x >= CASI_EN_CERO_FRACCION * max));
  const out: number[] = [];
  for (let k = Math.max(0, desde); k < consumos.length - 1; k++) {
    if (!Number.isFinite(r[k]!) || r[k]! >= CASI_EN_CERO_FRACCION * referencia) break;
    out.push(k);
  }
  return out;
}

/** hoy83: dónde empieza el recibo en una serie en orden: el primer renglón que NO escribió el vendedor (origen distinto de
 *  «manual»). Si todos son a mano (captura a mano), desde el primero. Lo usan el botón y el aviso del motor (la misma regla). */
export function inicioDelRecibo(origenes: readonly (string | null | undefined)[]): number {
  const k = origenes.findIndex((o) => o !== 'manual');
  return k < 0 ? 0 : k;
}

const NOMBRES_MES: Readonly<Record<string, number>> = Object.freeze({
  ENERO: 1, FEBRERO: 2, MARZO: 3, ABRIL: 4, MAYO: 5, JUNIO: 6, JULIO: 7, AGOSTO: 8, SEPTIEMBRE: 9, SETIEMBRE: 9, OCTUBRE: 10, NOVIEMBRE: 11, DICIEMBRE: 12,
  ENE: 1, FEB: 2, MAR: 3, ABR: 4, MAY: 5, JUN: 6, JUL: 7, AGO: 8, SEP: 9, SEPT: 9, SET: 9, OCT: 10, NOV: 11, DIC: 12,
});
/** El mes que dice una etiqueta escrita a mano: «Octubre», «oct», «OCT 25», «octubre 2025». null si no dice ninguno. */
export function mesEscrito(etiqueta: string): { mes: number; anio: number | null } | null {
  const t = etiqueta.toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  const m = /^([A-Z]{3,10})\.?(?:[\s\-/]+(?:DE[\s]+)?(\d{2}|\d{4}))?$/.exec(t);
  if (!m) return null;
  const mes = NOMBRES_MES[m[1]!];
  if (!mes) return null;
  const n = m[2] ? Number(m[2]) : null;
  return { mes, anio: n === null ? null : n < 100 ? 2000 + n : n };
}

const MESES_ETIQUETA_CFE: Readonly<Record<string, number>> = Object.freeze({ ENE: 1, FEB: 2, MAR: 3, ABR: 4, MAY: 5, JUN: 6, JUL: 7, AGO: 8, SEP: 9, SEPT: 9, OCT: 10, NOV: 11, DIC: 12 });
/** hoy83: ¿la etiqueta trae sus dos fechas como las imprime CFE («16 FEB 26-11 MAR 26»)? El motor las lee de ahí (leerEtiqueta, la
 *  misma forma) aunque el renglón no traiga inicio y fin: ese renglón SÍ se puede ubicar (no es «sin fechas»). */
export function etiquetaConFechas(etiqueta: string): boolean {
  const r = /^(\d{1,2}) ?([A-Z]{3,4}) ?(\d{2,4}) ?[-–A] ?(\d{1,2}) ?([A-Z]{3,4}) ?(\d{2,4})$/.exec(etiqueta.toUpperCase().replace(/\s+/g, ' ').trim());
  return !!r && !!MESES_ETIQUETA_CFE[r[2]!] && !!MESES_ETIQUETA_CFE[r[5]!];
}

export interface RenglonParaCompletar {
  inicio: string | null;
  fin: string | null;
  etiqueta: string;
  /** null = sin consumo escrito (no cuenta). */
  kwh: number | null;
  /** El origen del renglón (recibo, historial_recibo, manual, estimado). */
  origen?: string | null;
  /** Lo proyectó la IA (tanda 2): no se toca. */
  proyectado?: boolean;
}

export interface PeriodoCompletado {
  inicio: string;
  fin: string;
  etiqueta: string;
  kwh: number;
}

export interface PlanCompletarAnio {
  bimestral: boolean;
  /** 12 (mensual) o 6 (bimestral). */
  n: number;
  /** hoy83: los periodos del año que YA traen consumo (con fechas, dentro del año): los mismos que cuenta el resumen de la tabla
   *  («8 meses · …»), para que el recuadro «El año trae N de 12» cuadre con lo que se ve. */
  tienen: number;
  /** Periodos que faltaban en el año (n − tienen): los que se agregan, los que ocupan los renglones sin fechas y los renglones
   *  con fechas que no traen consumo. */
  faltaban: number;
  /** El primer periodo del alta (más corto que un periodo): se toma como el periodo completo que termina en su corte. */
  alta: { indice: number; inicio: string; etiqueta: string; dias: number } | null;
  /** Renglones casi en cero al principio que se estiman (índice en los renglones y kWh estimados). */
  casiCero: { indice: number; kwh: number; antes: number; inicio: string; fin: string }[];
  /** Renglones sin fechas (agregados «hacia adelante») que pasan al lugar que les toca. */
  adelantados: { indice: number; inicio: string; fin: string; etiqueta: string }[];
  /** Renglones sin fechas que ya no caben en el año (sobran). */
  sinLugar: number[];
  /** Periodos nuevos (hacia atrás o en los huecos), estimados. */
  nuevos: PeriodoCompletado[];
  /** hoy83: renglones CON fechas dentro del año y SIN consumo (los que el vendedor agregó con «Agregar antes/después» y no
   *  llenó): ya ocupan su lugar; se estiman ahí (antes el botón agregaba OTRO periodo con las mismas fechas). */
  vacios: { indice: number; kwh: number; inicio: string; fin: string }[];
  /** hoy86 (z64-2): los periodos REALES con que se estimó (sin los casi en cero ni los ya estimados), con las fechas con que los
   *  cuenta el plan (el alta, como el periodo completo): lo mismo que recibe la IA en «Sugerir con IA». */
  reales: { indice: number; inicio: string; fin: string; kwh: number }[];
  /** Con qué se estimó: el tramo de los meses reales y el consumo del año que da la curva con ellos. */
  base: { tramo: string; kwh_anual: number; meses: number };
  /** hoy85: no hay meses reales con que estimar (todos estimados o proyectados): los que faltan se ponen en blanco, pero «Sugerir con
   *  IA» no tiene con qué (sus kWh estimados valen 0 y no se usan). */
  sinBase: boolean;
}

export interface OpcionesCompletar {
  facturacion: 'mensual' | 'bimestral';
  /** Negocio (comercio o industria): la curva de negocios; si no, la de casas. */
  negocio: boolean;
  /** «AAAA-MM-DD» de Hermosillo (la ventana del año, como la tabla y el motor). */
  hoy: string;
  /** Ampliación (ya tiene paneles): sus meses bajos son de los paneles, no de una casa sin habitar: no se tocan. */
  ampliacion?: boolean;
}

/** El motivo que queda en cada periodo estimado (y en el historial de la cotización). z61: lo pone el botón «Sugerir con IA» y
 *  dice CON QUÉ se estimó (la curva de calor de Sonora con los meses reales), para que nadie lo tome por un recibo. */
export const MOTIVO_COMPLETAR = 'Sugerir con IA';
export const motivoCompletar = (b: PlanCompletarAnio['base']) =>
  `${MOTIVO_COMPLETAR}: estimado con la curva de calor de Sonora a partir de ${b.tramo} (${numero(b.kwh_anual)} kWh al año).`;

/** hoy85 (verificadores): por qué no se arma el plan cuando es algo que el vendedor tiene que ver JUNTO a la tabla. */
export interface MotivoSinPlan {
  motivo: string;
  /** Los renglones que hay que revisar (en rojo en la tabla). */
  indices: number[];
  /** El CÁLCULO tampoco sale así (un periodo que dura de más o de menos, periodos encimados, un hueco que no alcanza): «Autorizar»
   *  apagado. false = el cálculo saldría estimando lo que falta, pero el cotizador no pudo poner los meses (red de seguridad). */
  calculoTruena: boolean;
}

/** Un periodo del año como lo cuenta el cálculo: un renglón, o un mes PARTIDO en dos o más renglones (cambio de medidor) que se suma. */
interface Unidad {
  /** El renglón que lo representa (el primero del mes partido). */
  i: number;
  filas: number[];
  inicio: string;
  fin: string;
  /** null = el renglón no trae consumo (un periodo que puso el cotizador en blanco). */
  kwh: number | null;
}

/** Meses PARTIDOS en dos o más renglones CON fechas: la MISMA regla del motor (periodos.ts → mesesPartidos): renglones que duran menos
 *  que un periodo, seguidos (uno termina donde empieza el otro, ± 1 día), que juntos sí duran uno. Caso real del 25-oct: «15 FEB–15
 *  MAR» y «15 MAR–31 MAR». Solo renglones con consumo (uno en blanco no se suma con nada). */
function mesesPartidos(renglones: readonly RenglonParaCompletar[], candidatos: readonly number[], [dmin, dmax]: readonly [number, number]): number[][] {
  const cortos = candidatos.filter((i) => dias(renglones[i]!.inicio!, renglones[i]!.fin!) < dmin).sort((a, b) => aDia(renglones[a]!.inicio!) - aDia(renglones[b]!.inicio!) || a - b);
  const grupos: number[][] = [];
  let grupo: number[] = [];
  const cerrar = () => {
    if (grupo.length > 1) {
      const n = dias(renglones[grupo[0]!]!.inicio!, renglones[grupo[grupo.length - 1]!]!.fin!);
      if (n >= dmin && n <= dmax) grupos.push(grupo);
    }
    grupo = [];
  };
  for (const x of cortos) {
    const u = grupo[grupo.length - 1];
    if (u === undefined || Math.abs(dias(renglones[u]!.fin!, renglones[x]!.inicio!)) > 1 || dias(renglones[grupo[0]!]!.inicio!, renglones[x]!.fin!) > dmax) cerrar();
    grupo.push(x);
  }
  cerrar();
  return grupos;
}

/** La regla única de «los últimos 12 meses» sobre la tabla: el plan (qué poner, qué sugerir) o, si no se puede, POR QUÉ (hoy85). Las
 *  dos salen de aquí para que no se separen: antes el plan no sabía de meses partidos ni de periodos repetidos (que el cálculo sí
 *  acepta) y no se armaba; «por qué» decía null a propósito y la tabla se autorizaba con 8 de 12 meses sin que nadie lo viera. */
function analizarAnio(renglones: readonly RenglonParaCompletar[], o: OpcionesCompletar): { plan: PlanCompletarAnio | null; motivo: MotivoSinPlan | null } {
  const nada = { plan: null, motivo: null };
  const bimestral = o.facturacion === 'bimestral';
  const paso = bimestral ? 2 : 1;
  const n = bimestral ? 6 : 12;
  const [dmin, dmax] = bimestral ? [54, 67] : [25, 36];
  const unidadTxt = bimestral ? 'bimestre' : 'mes';
  const perfil = o.negocio ? PERFIL_CONSUMO_NEGOCIO : PERFIL_CONSUMO_CASA;
  const r = (i: number) => renglones[i]!;
  const conKwh = (x: RenglonParaCompletar) => x.kwh !== null && Number.isFinite(x.kwh) && x.kwh >= 0;
  const fechado = (x: RenglonParaCompletar) => esFecha(x.inicio) && esFecha(x.fin) && dias(x.inicio!, x.fin!) > 0;
  const v = ventanaDelAnio(renglones.map((x) => ({ fin: x.fin, etiqueta: x.etiqueta, ...(x.origen ? { origen: x.origen } : {}) })), o.facturacion, o.hoy);
  const dentro = new Set(v.dentro);
  const idx = renglones.map((_, i) => i);
  // Renglones SIN fechas: los que traen un mes de CFE legible («ABR 26», el historial impreso de GDMTO/GDMTH) los ubica el motor
  // con su mes: esa tabla no es para este botón (no se ofrece y no se toca nada). Los que NO dicen un mes de CFE («Octubre»,
  // «Periodo 9»: los que el vendedor agregó con «Agregar periodo» y escribió a mano) son los que el motor no puede ubicar.
  // hoy83: igual con los que traen sus dos fechas en la etiqueta («16 FEB 26-11 MAR 26» sin inicio ni fin): el motor los lee de ahí.
  if (idx.some((i) => !fechado(r(i)) && (mesDelRenglon({ fin: null, etiqueta: r(i).etiqueta }) !== null || etiquetaConFechas(r(i).etiqueta)) && dentro.has(i))) return nada;
  const D = idx.filter((i) => dentro.has(i) && fechado(r(i)) && conKwh(r(i)));
  if (!D.length) return nada;
  // hoy83: los renglones con fechas dentro del año que NO traen consumo («Agregar antes» sin llenar, los que puso el cotizador) ocupan su lugar.
  const V = idx.filter((i) => dentro.has(i) && fechado(r(i)) && !conKwh(r(i)));
  const sinFechas = idx.filter((i) => !fechado(r(i)) && conKwh(r(i)) && mesDelRenglon({ fin: null, etiqueta: r(i).etiqueta }) === null);
  const tramo = (i: number) => `${diaMesCorto(r(i).inicio!)} – ${diaMesCorto(r(i).fin!)}`;
  // hoy85: un mes PARTIDO en dos renglones (cambio de medidor) es UN periodo, como en el cálculo (antes el plan no se armaba).
  const grupos = mesesPartidos(renglones, D, [dmin, dmax]);
  const enGrupo = new Set(grupos.flat());
  // El alta: el periodo MÁS VIEJO de todo el historial, dentro del año, más corto que un periodo y que no es la mitad de un mes partido.
  const todos = idx.filter((i) => fechado(r(i))).sort((a, b) => aDia(r(a).inicio!) - aDia(r(b).inicio!));
  const primero = todos[0]!;
  const d0 = dias(r(primero).inicio!, r(primero).fin!);
  const alta = D.includes(primero) && !enGrupo.has(primero) && d0 < dmin ? { indice: primero, inicio: sumarMesesFecha(r(primero).fin!, -paso), etiqueta: etiquetaDeFechas(sumarMesesFecha(r(primero).fin!, -paso), r(primero).fin!), dias: d0 } : null;
  let unidades: Unidad[] = [
    ...grupos.map((g) => ({ i: g[0]!, filas: g, inicio: r(g[0]!).inicio!, fin: r(g[g.length - 1]!).fin!, kwh: g.reduce((t, k) => t + r(k).kwh!, 0) })),
    ...[...D, ...V].filter((i) => !enGrupo.has(i)).map((i) => ({ i, filas: [i], inicio: i === alta?.indice ? alta.inicio : r(i).inicio!, fin: r(i).fin!, kwh: conKwh(r(i)) ? r(i).kwh : null })),
  ].sort((a, b) => aDia(a.fin) - aDia(b.fin) || a.i - b.i);
  // hoy85: un periodo REPETIDO (mismo corte ± 3 días: el mismo recibo subido dos veces, o su renglón del historial) cuenta una vez, como
  // en el cálculo (antes «se enciman 30 días» en rojo sobre una tabla que el cálculo sí acepta). Se queda el que trae consumo y, entre
  // dos con consumo, el del recibo.
  const mejor = (u: Unidad) => (u.kwh !== null ? 2 : 0) + (u.filas.some((k) => r(k).origen === 'recibo') ? 1 : 0);
  const unicas: Unidad[] = [];
  for (const u of unidades) {
    const w = unicas[unicas.length - 1];
    if (w && Math.abs(aDia(u.fin) - aDia(w.fin)) <= 3) {
      if (mejor(u) > mejor(w)) unicas[unicas.length - 1] = u;
      continue;
    }
    unicas.push(u);
  }
  unidades = unicas;
  // Lo raro (un periodo corto o largo a la mitad, periodos que se enciman, un hueco que no alcanza) no se arregla solo: el cálculo
  // tampoco lo acepta y el vendedor lo tiene que ver ANTES, junto a la tabla.
  for (const u of unidades) {
    if (u.i === alta?.indice || u.filas.length > 1) continue;
    const d = dias(u.inicio, u.fin);
    if (d < dmin || d > dmax) return { plan: null, motivo: { motivo: `el periodo ${tramo(u.i)} dura ${d} días y un ${unidadTxt} de CFE dura de ${dmin} a ${dmax}`, indices: [u.i], calculoTruena: true } };
  }
  const vacio = new Set(unidades.filter((u) => u.kwh === null).map((u) => u.i));
  const huecos: { inicio: string; fin: string }[] = [];
  for (let k = 1; k < unidades.length; k++) {
    const a = unidades[k - 1]!, b = unidades[k]!;
    const h = dias(a.fin, b.inicio);
    if (h < -3) return { plan: null, motivo: { motivo: `los periodos ${tramo(a.i)} y ${tramo(b.i)} se enciman ${-h} días`, indices: [a.i, b.i], calculoTruena: true } };
    if (h <= 5) continue;
    // Huecos entre dos periodos (un recibo que no está): los periodos que caben, como el motor (serieDeLectura).
    const cuantos = Math.round(h / (30.44 * paso));
    const aqui: { inicio: string; fin: string }[] = [];
    let ini = a.fin;
    for (let j = 0; j < cuantos; j++) {
      const fin = j === cuantos - 1 ? b.inicio : sumarMesesFecha(ini, paso);
      aqui.push({ inicio: ini, fin });
      ini = fin;
    }
    if (cuantos < 1 || aqui.some((x) => dias(x.inicio, x.fin) < dmin || dias(x.inicio, x.fin) > dmax))
      return { plan: null, motivo: { motivo: `entre el ${diaMesCorto(a.fin)} y el ${diaMesCorto(b.inicio)} hay ${h} días sin periodo: no alcanza para ${cuantos < 1 ? `un ${unidadTxt} completo` : `${cuantos} ${bimestral ? 'bimestres' : 'meses'} completos`}`, indices: [a.i, b.i], calculoTruena: true } };
    huecos.push(...aqui);
  }
  // Más periodos que el año (no debería: la ventana ya es del año): no falta nada que poner.
  if (unidades.length + huecos.length > n) return nada;
  // Hacia atrás, desde el primero, hasta tener el año.
  const atras: { inicio: string; fin: string }[] = [];
  let cursor = unidades[0]!.inicio;
  while (unidades.length + huecos.length + atras.length < n) {
    const ini = sumarMesesFecha(cursor, -paso);
    atras.unshift({ inicio: ini, fin: cursor });
    cursor = ini;
  }
  const lugares = [...atras, ...huecos].sort((a, b) => aDia(a.fin) - aDia(b.fin));
  // Los meses reales con que se estima: los del año con consumo, sin los ya estimados ni los proyectados por la IA; los casi en cero
  // AL PRINCIPIO DEL RECIBO (servicio nuevo) se estiman también. Nunca en una ampliación (sus meses bajos son de los paneles). hoy83:
  // «al principio» es donde empieza el recibo: los meses que el vendedor agregó antes del alta no cuentan como principio.
  const base = unidades.filter((u) => u.kwh !== null && u.filas.every((k) => r(k).origen !== 'estimado' && !r(k).proyectado));
  const pesos = base.map((u) => pesoDelPeriodoEnElAnio(u.inicio, u.fin, perfil));
  const desde = inicioDelRecibo(base.map((u) => r(u.i).origen));
  const casiTodos = o.ampliacion ? [] : casiEnCeroAlInicio(base.map((u) => u.kwh!), pesos, desde);
  // Un mes partido no se estima como un renglón: la serie de casi en cero se corta ahí.
  const corte = casiTodos.findIndex((k) => base[k]!.filas.length > 1);
  const casi = corte < 0 ? casiTodos : casiTodos.slice(0, corte);
  // Solo se ofrece si al año le FALTAN periodos, hay renglones sin fechas que ubicar o sin consumo que llenar; con el año
  // completo, solo si el vendedor agregó meses ANTES del recibo y el recibo empieza casi en cero (hoy83).
  if (!lugares.length && !sinFechas.length && !vacio.size && !(casi.length && desde > 0)) return nada;
  const reales = base.filter((_, k) => !casi.includes(k));
  const pesosReales = reales.map((u) => pesoDelPeriodoEnElAnio(u.inicio, u.fin, perfil));
  const sumaPesos = pesosReales.reduce((a, b) => a + b, 0);
  // hoy85: sin meses reales con que estimar (todos estimados o proyectados) igual se ponen los que faltan en blanco: solo no se sugiere.
  const sinBase = !reales.length || !(sumaPesos > 0);
  const anual = sinBase ? 0 : reales.reduce((t, u) => t + u.kwh!, 0) / sumaPesos;
  const estimar = (inicio: string, fin: string) => (sinBase ? 0 : Math.round(anual * pesoDelPeriodoEnElAnio(inicio, fin, perfil)));
  // Los renglones sin fechas: primero al lugar de SU mes (si lo dicen: «Octubre», «OCT 25»), luego en orden en los que quedan.
  const ocupado = new Set<number>();
  const asignado = new Map<number, number>();
  const mesesDe = (l: { inicio: string; fin: string }) => {
    const medio = (aDia(l.inicio) + aDia(l.fin)) / 2;
    const marcas = bimestral ? [medio - 15, medio + 15] : [medio];
    return marcas.map((x) => { const d = new Date(Math.round(x) * DIA_MS); return { mes: d.getUTCMonth() + 1, anio: d.getUTCFullYear() }; });
  };
  for (const i of sinFechas) {
    const e = mesEscrito(r(i).etiqueta) ?? (() => { const k = mesDelRenglon({ fin: null, etiqueta: r(i).etiqueta }); return k ? { mes: Number(k.slice(5, 7)), anio: Number(k.slice(0, 4)) } : null; })();
    if (!e) continue;
    const k = lugares.findIndex((l, j) => !ocupado.has(j) && mesesDe(l).some((x) => x.mes === e.mes && (e.anio === null || x.anio === e.anio)));
    if (k >= 0) { ocupado.add(k); asignado.set(i, k); }
  }
  const sinLugar: number[] = [];
  for (const i of sinFechas) {
    if (asignado.has(i)) continue;
    const k = lugares.findIndex((_, j) => !ocupado.has(j));
    if (k < 0) { sinLugar.push(i); continue; }
    ocupado.add(k);
    asignado.set(i, k);
  }
  const nuevos = lugares.flatMap((l, j) => (ocupado.has(j) ? [] : [{ inicio: l.inicio, fin: l.fin, etiqueta: etiquetaDeFechas(l.inicio, l.fin), kwh: estimar(l.inicio, l.fin) }]));
  const adelantados = [...asignado].map(([i, k]) => ({ indice: i, inicio: lugares[k]!.inicio, fin: lugares[k]!.fin, etiqueta: etiquetaDeFechas(lugares[k]!.inicio, lugares[k]!.fin) }));
  return {
    plan: {
      bimestral,
      n,
      tienen: unidades.filter((u) => u.kwh !== null).length,
      faltaban: lugares.length + vacio.size,
      alta,
      casiCero: sinBase ? [] : casi.map((k) => { const u = base[k]!; return { indice: u.i, kwh: estimar(u.inicio, u.fin), antes: u.kwh!, inicio: u.inicio, fin: u.fin }; }),
      adelantados,
      sinLugar,
      nuevos,
      vacios: unidades.filter((u) => vacio.has(u.i)).map((u) => ({ indice: u.i, kwh: estimar(u.inicio, u.fin), inicio: u.inicio, fin: u.fin })),
      // hoy86 (z64-2): los reales con que se estimó (un mes partido, sumado, como lo cuenta el cálculo): lo que recibe la IA.
      reales: sinBase ? [] : reales.map((u) => ({ indice: u.i, inicio: u.inicio, fin: u.fin, kwh: u.kwh! })),
      base: sinBase ? { tramo: '', kwh_anual: 0, meses: 0 } : { tramo: tramoDeMeses(reales[0]!.inicio, reales[reales.length - 1]!.fin), kwh_anual: Math.round(anual), meses: reales.length },
      sinBase,
    },
    motivo: null,
  };
}

/** El plan de «Completar el año» para lo que está en la tabla. null = no hay nada que completar (el año ya está, no hay fechas
 *  para ubicarlo) o la tabla trae algo raro que el vendedor debe revisar (motivoSinPlan dice qué: periodos cortos o largos a la
 *  mitad, periodos que se enciman). Solo se ofrece si al año le FALTAN periodos o hay renglones sin fechas que ubicar. hoy85: un mes
 *  partido en dos renglones y un periodo repetido cuentan como el cálculo los cuenta (uno). */
export function planCompletarAnio(renglones: readonly RenglonParaCompletar[], o: OpcionesCompletar): PlanCompletarAnio | null {
  return analizarAnio(renglones, o).plan;
}

/** hoy85 (verificadores de hoy84 y hoy85: «z61 se salta en silencio»): POR QUÉ no se arma el plan, cuando es por algo que el CÁLCULO
 *  TAMPOCO acepta en el año que se cotiza (un periodo a la mitad que dura de más o de menos, periodos que se enciman, un hueco que no
 *  alcanza). Con eso la tabla no se debe autorizar como está y el vendedor tiene que verlo ANTES, junto a la tabla. null = el plan sí
 *  se arma, o no hace falta (el año está completo, la tabla es el historial impreso de GDMT sin fechas). Sale de la MISMA cuenta que
 *  el plan (analizarAnio): un mes partido o un periodo repetido no es «raro» (el cálculo los suma o los cuenta una vez). */
export function motivoSinPlan(renglones: readonly RenglonParaCompletar[], o: OpcionesCompletar): MotivoSinPlan | null {
  return analizarAnio(renglones, o).motivo;
}

/** «16 oct 25 – 16 feb 26»: el tramo de unos periodos (para el texto del vendedor). */
export function tramoDeFechas(periodos: readonly { inicio: string; fin: string }[]): string {
  if (!periodos.length) return '';
  const o = [...periodos].sort((a, b) => aDia(a.inicio) - aDia(b.inicio));
  return `${diaMesCorto(o[0]!.inicio)} – ${diaMesCorto(o[o.length - 1]!.fin)}`;
}

/** hoy86 (z64-2): un periodo del año que «Sugerir con IA» llena, en orden de fechas. `destino` dice dónde va en la tabla: un
 *  periodo nuevo (`nuevo`: el k-ésimo de plan.nuevos), un renglón en blanco (`vacio`) o uno casi en cero del principio
 *  (`casi_cero`), con su `indice` en los renglones. `curva` = lo que da la curva de Sonora (lo que se pone si la IA no sirve). */
export interface PeriodoPorEstimar {
  destino: 'nuevo' | 'vacio' | 'casi_cero';
  /** índice en plan.nuevos (destino «nuevo») o en los renglones de la tabla («vacio», «casi_cero»). */
  indice: number;
  inicio: string;
  fin: string;
  curva: number;
}

/** Todo lo que el plan estima, en orden de fechas: lo que se le pide a la IA (sus fechas) y lo que pone la curva si la IA no sirve. */
export function porEstimarDelPlan(plan: PlanCompletarAnio): PeriodoPorEstimar[] {
  const todos: PeriodoPorEstimar[] = [
    ...plan.nuevos.map((p, k) => ({ destino: 'nuevo' as const, indice: k, inicio: p.inicio, fin: p.fin, curva: p.kwh })),
    ...plan.vacios.map((v) => ({ destino: 'vacio' as const, indice: v.indice, inicio: v.inicio, fin: v.fin, curva: v.kwh })),
    ...plan.casiCero.map((c) => ({ destino: 'casi_cero' as const, indice: c.indice, inicio: c.inicio, fin: c.fin, curva: c.kwh })),
  ];
  return todos.sort((a, b) => aDia(a.fin) - aDia(b.fin) || aDia(a.inicio) - aDia(b.inicio));
}
